// notes.ts - Modern Notion/Linear style notes workspace logic with Rich Text, Pinning, Reordering, Title Selection & Mobile Adaptation
document.addEventListener('DOMContentLoaded', () => {
    let currentNotes: any[] = [];
    let activeNoteId: any = null;
    let searchQuery: string = '';
    let contextTargetNoteId: any = null;

    const containerEl = document.getElementById('notes-container') as HTMLElement | null;
    const listEl = document.getElementById('notes-list');
    const editorInnerEl = document.getElementById('notes-editor-inner') as HTMLElement | null;
    const emptyStateEl = document.getElementById('notes-empty-state') as HTMLElement | null;
    let titleEl = document.getElementById('note-title') as HTMLElement | null;
    let contentEl = document.getElementById('note-content') as HTMLElement | null;
    const saveBtn = document.getElementById('save-note-btn');
    const deleteBtn = document.getElementById('delete-note-btn');
    const pinBtn = document.getElementById('pin-note-btn');
    const backBtn = document.getElementById('notes-back-btn');
    const newBtn = document.getElementById('new-note-btn');
    const emptyNewBtn = document.getElementById('empty-new-note-btn');
    const headerAddBtn = document.getElementById('notes-add-btn');
    const searchInput = document.getElementById('notes-search-input') as HTMLInputElement | null;
    const saveStatusEl = document.getElementById('note-save-status');

    // Фото та медіа
    const imageFileInput = document.getElementById('note-image-file-input') as HTMLInputElement | null;

    // Context Menu & Link Modal elements
    const contextMenu = document.getElementById('notes-context-menu');
    const menuPinBtn = document.getElementById('notes-menu-pin');
    const menuPinLabel = document.getElementById('notes-menu-pin-label');
    const menuDuplicateBtn = document.getElementById('notes-menu-duplicate');
    const menuCopyContentBtn = document.getElementById('notes-menu-copy-content');
    const menuMoveUpBtn = document.getElementById('notes-menu-move-up');
    const menuMoveDownBtn = document.getElementById('notes-menu-move-down');
    const menuEditorDivider = document.getElementById('notes-menu-editor-divider');
    const menuInsertPhotoBtn = document.getElementById('notes-menu-insert-photo');
    const menuCopyImageBtn = document.getElementById('notes-menu-copy-image');
    const menuCopyImageUrlBtn = document.getElementById('notes-menu-copy-image-url');
    const menuViewImageBtn = document.getElementById('notes-menu-view-image');
    const menuDeleteImageBtn = document.getElementById('notes-menu-delete-image');
    const menuFormatDivider = document.getElementById('notes-menu-format-divider');
    const menuLinkLabel = document.getElementById('notes-menu-link-label');
    const menuOpenLinkBtn = document.getElementById('notes-menu-open-link');
    const menuUnlinkBtn = document.getElementById('notes-menu-unlink');

    const linkModalOverlay = document.getElementById('note-link-modal-overlay');
    const linkModalTitle = document.getElementById('note-link-modal-title');
    const linkTextInput = document.getElementById('note-link-text-input') as HTMLInputElement | null;
    const linkUrlInput = document.getElementById('note-link-url-input') as HTMLInputElement | null;
    const linkSaveBtn = document.getElementById('note-link-save-btn');
    const linkCancelBtn = document.getElementById('note-link-cancel-btn');
    const linkCloseBtn = document.getElementById('note-link-modal-close');

    // Image Modal (Lightbox) elements
    const imageModalOverlay = document.getElementById('note-image-modal-overlay');
    const imageModalImg = document.getElementById('note-image-modal-img') as HTMLImageElement | null;
    const imageModalCopyBtn = document.getElementById('note-modal-copy-img-btn');
    const imageModalDownloadBtn = document.getElementById('note-modal-download-img-btn') as HTMLAnchorElement | null;
    const imageModalCloseBtn = document.getElementById('note-image-modal-close');
    const notesDocEl = document.getElementById('notes-document') as HTMLElement | null;

    let savedRange: Range | null = null;
    let clickedLinkEl: HTMLAnchorElement | null = null;
    let clickedImageEl: HTMLImageElement | null = null;
    let draggedNoteId: any = null;
    let isDraggingNote = false;

    (window as any).loadNotes = loadNotes;
    (window as any).togglePinNote = togglePinNote;
    (window as any).moveNote = moveNote;
    (window as any).duplicateNote = duplicateNote;
    (window as any).copyFullNoteContent = copyFullNoteContent;
    (window as any).copyImageToClipboard = copyImageToClipboard;
    (window as any).toggleHighlight = toggleHighlight;

    function isMobileView(): boolean {
        return window.innerWidth <= 768;
    }

    function showMobileEditor() {
        if (containerEl && isMobileView()) {
            containerEl.classList.add('mobile-view-editor');
        }
    }

    function hideMobileEditor() {
        if (containerEl) {
            containerEl.classList.remove('mobile-view-editor');
        }
    }

    function stripHtml(html: string): string {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }

    function formatNoteSnippet(rawContent: string): string {
        const text = stripHtml(rawContent || '')
            .replace(/[#*`_~-]/g, '')
            .trim();
        if (!text) return '';

        const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
        const normalized = lines.join(' ');

        if (normalized.length > 90) {
            const cut = normalized.slice(0, 90);
            const lastSpace = cut.lastIndexOf(' ');
            return (lastSpace > 50 ? cut.slice(0, lastSpace) : cut) + '...';
        }
        return normalized;
    }

    function getNoteTitle(): string {
        return titleEl ? (titleEl.innerText || titleEl.textContent || '').trim() : '';
    }

    function setNoteTitle(title: string) {
        if (!titleEl) return;
        titleEl.innerText = title || '';
        updateTitleEmptyState();
    }

    function updateTitleEmptyState() {
        if (!titleEl) return;
        const text = (titleEl.innerText || titleEl.textContent || '').trim();
        if (!text) {
            titleEl.setAttribute('data-empty', 'true');
        } else {
            titleEl.removeAttribute('data-empty');
        }
    }

    function selectAllTitle() {
        if (!titleEl) return;
        const range = document.createRange();
        range.selectNodeContents(titleEl);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
    }

    function updateEmptyState() {
        if (!contentEl) return;
        const text = contentEl.textContent || '';
        if (!text.trim() && !contentEl.querySelector('img, a, hr')) {
            contentEl.setAttribute('data-empty', 'true');
        } else {
            contentEl.removeAttribute('data-empty');
        }
    }

    async function loadNotes() {
        try {
            const res = await fetch('api/notes.php?action=list');
            const data = await res.json();
            if (data.success) {
                currentNotes = data.data || [];
                (window as any).setSidebarBadge?.('notes', currentNotes.length, 'default', `Нотаток: ${currentNotes.length}`);
                renderNotesList();

                if (currentNotes.length === 0) {
                    showEmptyState();
                } else if (!activeNoteId) {
                    // На десктопі відкриваємо першу нотатку, на мобільному показуємо список
                    if (!isMobileView()) {
                        openNote(currentNotes[0], false);
                    } else {
                        activeNoteId = currentNotes[0].id;
                    }
                } else {
                    const found = currentNotes.find(n => Number(n.id) === Number(activeNoteId));
                    if (found) {
                        openNote(found, false);
                    } else if (!isMobileView()) {
                        openNote(currentNotes[0], false);
                    }
                }
            }
        } catch (e) {
            console.error('Failed to load notes', e);
        }
    }

    function updatePinButtonUI(isPinned: boolean) {
        if (!pinBtn) return;
        const icon = pinBtn.querySelector('i');
        const text = pinBtn.querySelector('.btn-text');

        if (isPinned) {
            pinBtn.classList.add('is-pinned');
            pinBtn.setAttribute('title', 'Відкріпити нотатку');
            if (icon) icon.className = 'ri-pushpin-2-fill';
            if (text) text.textContent = 'Закріплено';
        } else {
            pinBtn.classList.remove('is-pinned');
            pinBtn.setAttribute('title', 'Закріпити нотатку');
            if (icon) icon.className = 'ri-pushpin-line';
            if (text) text.textContent = 'Закріпити';
        }
    }

    async function togglePinNote(idToToggle: any, e?: Event) {
        if (e) e.stopPropagation();
        const noteId = idToToggle || activeNoteId;
        if (!noteId) return;

        try {
            const res = await fetch('api/notes.php?action=toggle_pin', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: noteId })
            });
            const data = await res.json();
            if (data.success) {
                const targetNote = currentNotes.find(n => Number(n.id) === Number(noteId));
                if (targetNote) {
                    targetNote.is_pinned = data.is_pinned;
                }

                if (Number(activeNoteId) === Number(noteId)) {
                    updatePinButtonUI(Boolean(data.is_pinned));
                }

                const msg = data.is_pinned ? 'Нотатку закріплено вгорі' : 'Нотатку відкріплено';
                if ((window as any).showMessage) {
                    (window as any).showMessage(msg, 'info');
                }

                await loadNotes();
            }
        } catch (err) {
            console.error('Failed to toggle pin', err);
        }
    }

    async function moveNote(id: any, direction: 'up' | 'down', e?: Event) {
        if (e) e.stopPropagation();
        const noteId = id || activeNoteId;
        if (!noteId) return;

        if (isDirty && activeNoteId && !isSaving) {
            await saveCurrentNote();
        }

        const idx = currentNotes.findIndex(n => Number(n.id) === Number(noteId));
        if (idx === -1) return;

        const currentItem = currentNotes[idx];
        const isCurrentPinned = Number(currentItem.is_pinned) === 1;

        // Знаходимо всі індекси нотаток у цій же секції (закріплені чи звичайні)
        const sameSectionIndices: number[] = [];
        currentNotes.forEach((n, i) => {
            if ((Number(n.is_pinned) === 1) === isCurrentPinned) {
                sameSectionIndices.push(i);
            }
        });

        const posInSection = sameSectionIndices.indexOf(idx);
        if (posInSection === -1) return;

        if (direction === 'up') {
            if (posInSection === 0) {
                if ((window as any).showMessage) {
                    (window as any).showMessage(isCurrentPinned ? 'Нотатка вже на самому верху закріплених' : 'Нотатка вже вгорі списку нотаток', 'info');
                }
                return;
            }
            const swapWithIdx = sameSectionIndices[posInSection - 1];
            const temp = currentNotes[idx];
            currentNotes[idx] = currentNotes[swapWithIdx];
            currentNotes[swapWithIdx] = temp;
        } else {
            if (posInSection === sameSectionIndices.length - 1) {
                if ((window as any).showMessage) {
                    (window as any).showMessage(isCurrentPinned ? 'Нотатка внизу списку закріплених' : 'Нотатка вже в самому низу списку', 'info');
                }
                return;
            }
            const swapWithIdx = sameSectionIndices[posInSection + 1];
            const temp = currentNotes[idx];
            currentNotes[idx] = currentNotes[swapWithIdx];
            currentNotes[swapWithIdx] = temp;
        }

        renderNotesList();
        await saveReorderedNotes();

        if ((window as any).showMessage) {
            (window as any).showMessage(direction === 'up' ? 'Нотатку переміщено вище' : 'Нотатку переміщено нижче', 'success');
        }
    }

    async function saveReorderedNotes() {
        try {
            const items = currentNotes.map((n, idx) => ({
                id: Number(n.id),
                sort_order: idx,
                is_pinned: Number(n.is_pinned) ? 1 : 0
            }));
            const ids = currentNotes.map(n => Number(n.id));
            await fetch('api/notes.php?action=reorder', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items, ids })
            });
        } catch (e) {
            console.error('Failed to save reordered notes', e);
        }
    }

    function renderNotesList() {
        if (!listEl) return;
        listEl.innerHTML = '';

        const filtered = currentNotes.filter(note => {
            if (!searchQuery.trim()) return true;
            const q = searchQuery.toLowerCase();
            const title = (note.title || '').toLowerCase();
            const textContent = stripHtml(note.content || '').toLowerCase();
            return title.includes(q) || textContent.includes(q);
        });

        if (filtered.length === 0) {
            const emptyItem = document.createElement('li');
            emptyItem.style.padding = '20px 12px';
            emptyItem.style.textAlign = 'center';
            emptyItem.style.fontSize = '12px';
            emptyItem.style.color = 'var(--text-dim)';
            emptyItem.innerText = searchQuery ? 'Нічого не знайдено' : 'Немає нотаток';
            listEl.appendChild(emptyItem);
            return;
        }

        const hasPinned = filtered.some(n => Number(n.is_pinned) === 1);
        let pinnedRendered = false;
        let regularRendered = false;

        filtered.forEach((note, index) => {
            const isPinned = Number(note.is_pinned) === 1;

            // Секційні розділювачі (якщо є закріплені і не активний пошук)
            if (hasPinned && !searchQuery.trim()) {
                if (isPinned && !pinnedRendered) {
                    const sec = document.createElement('li');
                    sec.className = 'notes-section-title';
                    sec.innerHTML = '<i class="ri-pushpin-2-fill"></i> <span>Закріплені</span>';
                    listEl.appendChild(sec);
                    pinnedRendered = true;
                } else if (!isPinned && !regularRendered) {
                    const sec = document.createElement('li');
                    sec.className = 'notes-section-title';
                    sec.innerHTML = '<i class="ri-draft-line"></i> <span>Нотатки</span>';
                    listEl.appendChild(sec);
                    regularRendered = true;
                }
            }

            const li = document.createElement('li');
            li.className = 'note-list-item' + 
                (Number(activeNoteId) === Number(note.id) ? ' active' : '') +
                (isPinned ? ' is-pinned' : '');
            li.setAttribute('draggable', 'true');
            li.dataset.id = String(note.id);
            li.dataset.index = String(index);

            // Drag handle
            const dragHandle = document.createElement('span');
            dragHandle.className = 'note-drag-handle';
            dragHandle.title = 'Перетягнути для зміни порядку';
            dragHandle.innerHTML = '<i class="ri-draggable"></i>';

            // Title row
            const titleRow = document.createElement('div');
            titleRow.className = 'note-item-header';

            const titleDiv = document.createElement('div');
            titleDiv.className = 'note-item-title';
            // Делікатна іконка нотатки перед назвою (закріплення відображається кнопкою-шпилькою праворуч)
            titleDiv.innerHTML = `<i class="ri-file-text-line"></i> <span class="note-title-text">${escapeHtml(note.title || 'Без назви')}</span>`;

            // Action buttons inside list item
            const actionsDiv = document.createElement('div');
            actionsDiv.className = 'note-item-actions';

            const pinBtnItem = document.createElement('button');
            pinBtnItem.type = 'button';
            pinBtnItem.className = 'note-item-pin-btn' + (isPinned ? ' is-pinned' : '');
            pinBtnItem.title = isPinned ? 'Відкріпити нотатку' : 'Закріпити зверху';
            pinBtnItem.innerHTML = `<i class="${isPinned ? 'ri-pushpin-2-fill' : 'ri-pushpin-line'}"></i>`;
            pinBtnItem.onclick = (e) => togglePinNote(note.id, e);

            actionsDiv.appendChild(pinBtnItem);

            titleRow.appendChild(dragHandle);
            titleRow.appendChild(titleDiv);
            titleRow.appendChild(actionsDiv);

            li.appendChild(titleRow);

            // Snippet (додається лише якщо є текст)
            const snippetText = formatNoteSnippet(note.content);
            if (snippetText) {
                const snippetDiv = document.createElement('div');
                snippetDiv.className = 'note-item-snippet';
                snippetDiv.innerText = snippetText;
                li.appendChild(snippetDiv);
            }

            // Click to open note
            li.onclick = (e) => {
                if (isDraggingNote) return;
                if ((e.target as HTMLElement)?.closest('.note-item-pin-btn')) return;
                openNote(note, true);
            };

            // Context Menu on list item
            li.oncontextmenu = (e: MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                contextTargetNoteId = note.id;
                showContextMenu(e.clientX, e.clientY, true, isPinned);
            };

            // HTML5 Drag & Drop handlers
            setupDragAndDrop(li, note);

            listEl.appendChild(li);
        });
    }

    function setupDragAndDrop(li: HTMLElement, note: any) {
        li.addEventListener('dragstart', (e: DragEvent) => {
            draggedNoteId = note.id;
            isDraggingNote = true;
            li.classList.add('is-dragging');
            if (e.dataTransfer) {
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/plain', String(note.id));
            }
        });

        li.addEventListener('dragover', (e: DragEvent) => {
            e.preventDefault();
            if (e.dataTransfer) {
                e.dataTransfer.dropEffect = 'move';
            }
            if (!draggedNoteId || Number(draggedNoteId) === Number(note.id)) return;

            const rect = li.getBoundingClientRect();
            const relY = e.clientY - rect.top;
            if (relY < rect.height / 2) {
                li.classList.add('drag-over-top');
                li.classList.remove('drag-over-bottom');
            } else {
                li.classList.add('drag-over-bottom');
                li.classList.remove('drag-over-top');
            }
        });

        li.addEventListener('dragleave', () => {
            li.classList.remove('drag-over-top', 'drag-over-bottom');
        });

        li.addEventListener('drop', async (e: DragEvent) => {
            e.preventDefault();
            const targetNoteId = note.id;
            li.classList.remove('drag-over-top', 'drag-over-bottom');

            if (!draggedNoteId || Number(draggedNoteId) === Number(targetNoteId)) return;

            const fromIdx = currentNotes.findIndex(n => Number(n.id) === Number(draggedNoteId));
            const toIdx = currentNotes.findIndex(n => Number(n.id) === Number(targetNoteId));

            if (fromIdx === -1 || toIdx === -1 || fromIdx === toIdx) return;

            const rect = li.getBoundingClientRect();
            const isBottom = (e.clientY - rect.top) >= rect.height / 2;

            let targetIndex: number;
            if (fromIdx < toIdx) {
                targetIndex = isBottom ? toIdx : toIdx - 1;
            } else {
                targetIndex = isBottom ? toIdx + 1 : toIdx;
            }

            if (targetIndex === fromIdx) return;
            targetIndex = Math.max(0, Math.min(targetIndex, currentNotes.length - 1));

            const [movedItem] = currentNotes.splice(fromIdx, 1);

            // Синхронізуємо закріплення з цільовою позицією
            const targetNote = currentNotes.find(n => Number(n.id) === Number(targetNoteId));
            if (targetNote) {
                movedItem.is_pinned = Number(targetNote.is_pinned) ? 1 : 0;
                if (Number(movedItem.id) === Number(activeNoteId)) {
                    updatePinButtonUI(Boolean(Number(movedItem.is_pinned)));
                }
            }

            currentNotes.splice(targetIndex, 0, movedItem);

            renderNotesList();
            await saveReorderedNotes();
        });

        li.addEventListener('dragend', () => {
            draggedNoteId = null;
            setTimeout(() => { isDraggingNote = false; }, 250);
            document.querySelectorAll('.note-list-item').forEach(el => {
                el.classList.remove('is-dragging', 'drag-over-top', 'drag-over-bottom');
            });
        });

        // Touch Drag Support for mobile handles
        const handle = li.querySelector('.note-drag-handle') as HTMLElement | null;
        if (handle) {
            let touchTargetLi: HTMLElement | null = null;

            handle.addEventListener('touchstart', (e: TouchEvent) => {
                draggedNoteId = note.id;
                isDraggingNote = true;
                li.classList.add('is-touch-dragging');
            }, { passive: true });

            handle.addEventListener('touchmove', (e: TouchEvent) => {
                const touchY = e.touches[0].clientY;
                const element = document.elementFromPoint(e.touches[0].clientX, touchY);
                const closestLi = element?.closest('.note-list-item') as HTMLElement | null;

                document.querySelectorAll('.note-list-item').forEach(item => {
                    item.classList.remove('drag-over-top', 'drag-over-bottom');
                });

                if (closestLi && closestLi !== li) {
                    touchTargetLi = closestLi;
                    const r = closestLi.getBoundingClientRect();
                    if (touchY - r.top < r.height / 2) {
                        closestLi.classList.add('drag-over-top');
                    } else {
                        closestLi.classList.add('drag-over-bottom');
                    }
                }
            }, { passive: true });

            handle.addEventListener('touchend', async () => {
                li.classList.remove('is-touch-dragging');
                if (touchTargetLi && draggedNoteId) {
                    const targetId = touchTargetLi.dataset.id;
                    const fromIdx = currentNotes.findIndex(n => Number(n.id) === Number(draggedNoteId));
                    const toIdx = currentNotes.findIndex(n => Number(n.id) === Number(targetId));

                    if (fromIdx !== -1 && toIdx !== -1 && fromIdx !== toIdx) {
                        const isBottom = touchTargetLi.classList.contains('drag-over-bottom');
                        let targetIndex: number;
                        if (fromIdx < toIdx) {
                            targetIndex = isBottom ? toIdx : toIdx - 1;
                        } else {
                            targetIndex = isBottom ? toIdx + 1 : toIdx;
                        }

                        if (targetIndex !== fromIdx) {
                            targetIndex = Math.max(0, Math.min(targetIndex, currentNotes.length - 1));
                            const [movedItem] = currentNotes.splice(fromIdx, 1);
                            const targetNote = currentNotes.find(n => Number(n.id) === Number(targetId));
                            if (targetNote) {
                                movedItem.is_pinned = Number(targetNote.is_pinned) ? 1 : 0;
                                if (Number(movedItem.id) === Number(activeNoteId)) {
                                    updatePinButtonUI(Boolean(Number(movedItem.is_pinned)));
                                }
                            }

                            currentNotes.splice(targetIndex, 0, movedItem);

                            renderNotesList();
                            await saveReorderedNotes();
                        }
                    }
                }

                document.querySelectorAll('.note-list-item').forEach(item => {
                    item.classList.remove('drag-over-top', 'drag-over-bottom');
                });
                touchTargetLi = null;
                draggedNoteId = null;
                setTimeout(() => { isDraggingNote = false; }, 250);
            });
        }
    }

    let autoSaveTimer: any = null;
    let isDirty: boolean = false;
    let isSaving: boolean = false;
    let editRevision = 0;

    function showEmptyState() {
        activeNoteId = null;
        if (editorInnerEl) editorInnerEl.style.display = 'none';
        if (emptyStateEl) emptyStateEl.style.display = 'flex';
        updatePinButtonUI(false);
    }

    async function openNote(note: any, triggerMobileView: boolean = true) {
        if (!note) {
            showEmptyState();
            return;
        }

        // Якщо попередня нотатка мала незбережені зміни, зберігаємо її перед відкриттям нової
        if (isDirty && activeNoteId && Number(activeNoteId) !== Number(note.id)) {
            await saveCurrentNote();
        }

        activeNoteId = note.id;
        isDirty = false;
        if (autoSaveTimer) {
            clearTimeout(autoSaveTimer);
            autoSaveTimer = null;
        }

        if (emptyStateEl) emptyStateEl.style.display = 'none';
        if (editorInnerEl) editorInnerEl.style.display = 'flex';
        
        setNoteTitle(note.title || '');
        
        if (contentEl) {
            const raw = note.content || '';
            if (/<[a-z][\s\S]*>/i.test(raw)) {
                contentEl.innerHTML = raw;
            } else {
                contentEl.innerHTML = escapeHtml(raw).replace(/\n/g, '<br>');
            }

            // Repair empty wrappers left by the former split-block handling.
            contentEl.querySelectorAll('div[class=""]').forEach(block => {
                if (block.firstChild?.nodeName === 'BR' &&
                    block.children[1]?.outerHTML === '<div><br></div>') {
                    block.firstChild.remove();
                    block.children[0]?.remove();
                }
            });

            contentEl.querySelectorAll('a').forEach(a => {
                a.classList.add('note-link');
                const href = a.getAttribute('href') || '';
                if (href) {
                    a.setAttribute('data-tooltip', href);
                    a.setAttribute('data-tooltip-pos', 'top');
                }
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'noopener noreferrer');
            });

            updateEmptyState();
        }
        
        updatePinButtonUI(Boolean(Number(note.is_pinned)));
        setSavedState();
        renderNotesList();

        if (triggerMobileView) {
            showMobileEditor();
        }
    }

    function setSavedState() {
        isDirty = false;
        if (saveStatusEl) {
            saveStatusEl.innerHTML = '<i class="ri-checkbox-circle-line"></i> Автозбережено';
            saveStatusEl.style.color = '#10b981';
        }
        if (saveBtn) {
            saveBtn.classList.add('is-saved');
        }
    }

    function setUnsavedState() {
        editRevision++;
        isDirty = true;
        if (saveStatusEl && !isSaving) {
            saveStatusEl.innerHTML = '<i class="ri-loader-4-line ri-spin"></i> Автозбереження...';
            saveStatusEl.style.color = '#f59e0b';
        }
        if (saveBtn) {
            saveBtn.classList.remove('is-saved');
        }
    }

    function markUnsaved() {
        setUnsavedState();
        triggerAutoSave();
    }

    function triggerAutoSave() {
        if (autoSaveTimer) {
            clearTimeout(autoSaveTimer);
        }
        autoSaveTimer = setTimeout(() => {
            if (isDirty && activeNoteId && !isSaving) {
                saveCurrentNote();
            }
        }, 900);
    }

    if (titleEl) {
        titleEl.addEventListener('blur', () => {
            if (isDirty && activeNoteId && !isSaving) {
                saveCurrentNote();
            }
        });

        titleEl.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (contentEl) {
                    contentEl.focus();
                    const sel = window.getSelection();
                    const range = document.createRange();
                    if (contentEl.firstChild) {
                        range.setStart(contentEl.firstChild, 0);
                    } else {
                        range.setStart(contentEl, 0);
                    }
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
                return;
            }

            if (e.key === 'ArrowDown') {
                if (contentEl) {
                    contentEl.focus();
                }
                return;
            }

            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'a') {
                e.preventDefault();
                const doc = document.getElementById('notes-document');
                if (doc) {
                    const range = document.createRange();
                    range.selectNodeContents(doc);
                    const sel = window.getSelection();
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        });

        titleEl.addEventListener('paste', (e: ClipboardEvent) => {
            e.preventDefault();
            const text = (e.clipboardData?.getData('text/plain') || '').replace(/[\r\n]+/g, ' ');
            document.execCommand('insertText', false, text);
            updateTitleEmptyState();
            markUnsaved();
        });
    }

    if (contentEl) {
        contentEl.addEventListener('blur', () => {
            if (isDirty && activeNoteId && !isSaving) {
                saveCurrentNote();
            }
        });

        // Відкриття посилання за допомогою Ctrl + Клік або відкриття фото у Lightbox
        contentEl.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const img = target.closest('img') as HTMLImageElement | null;
            if (img && contentEl.contains(img)) {
                openImageModal(img.src);
                return;
            }

            const link = target.closest('a.note-link') as HTMLAnchorElement | null;
            if (link && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                window.open(link.href, '_blank', 'noopener,noreferrer');
            }
        });

        // Вставка зображень із буфера обміну (Ctrl+V)
        contentEl.addEventListener('paste', async (e: ClipboardEvent) => {
            const items = e.clipboardData?.items;
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.type.indexOf('image') !== -1) {
                        e.preventDefault();
                        const file = item.getAsFile();
                        if (file) {
                            saveCurrentSelection();
                            const url = await uploadNoteImageFile(file);
                            if (url) {
                                insertImageElement(url, file.name || 'Вставлене фото');
                            }
                        }
                        return;
                    }
                }
            }
        });

        // Обробка клавіатури в полі нотатки
        contentEl.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'ArrowUp') {
                const sel = window.getSelection();
                if (sel && sel.isCollapsed && sel.anchorOffset === 0 && (sel.anchorNode === contentEl || sel.anchorNode === contentEl.firstChild)) {
                    if (titleEl) {
                        e.preventDefault();
                        titleEl.focus();
                        const r = document.createRange();
                        r.selectNodeContents(titleEl);
                        r.collapse(false);
                        sel.removeAllRanges();
                        sel.addRange(r);
                    }
                    return;
                }
            }

            if (e.key === 'Backspace') {
                const sel = window.getSelection();
                if (sel && sel.isCollapsed) {
                    const isAtStart = (
                        sel.anchorOffset === 0 && (
                            sel.anchorNode === contentEl || 
                            sel.anchorNode === contentEl.firstChild ||
                            (sel.anchorNode?.parentElement === contentEl && !sel.anchorNode.previousSibling)
                        )
                    );
                    if (isAtStart && titleEl) {
                        e.preventDefault();
                        titleEl.focus();
                        const r = document.createRange();
                        r.selectNodeContents(titleEl);
                        r.collapse(false);
                        sel.removeAllRanges();
                        sel.addRange(r);
                    }
                }
            }

            if (e.ctrlKey || e.metaKey) {
                const key = e.key.toLowerCase();
                if (key === 'a') {
                    // Ctrl+A виділяє весь документ нотатки (заголовок + вміст)
                    e.preventDefault();
                    const range = document.createRange();
                    range.selectNodeContents(notesDocEl || contentEl);
                    const sel = window.getSelection();
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                } else if (key === 'k') {
                    e.preventDefault();
                    saveCurrentSelection();
                    const target = e.target as HTMLElement;
                    clickedLinkEl = target.closest('a.note-link') as HTMLAnchorElement | null;
                    openLinkModal();
                } else if (key === 'h') {
                    e.preventDefault();
                    toggleHighlight();
                } else if (key === 'b') {
                    e.preventDefault();
                    document.execCommand('bold', false);
                    markUnsaved();
                    updateEmptyState();
                } else if (key === 'i') {
                    e.preventDefault();
                    document.execCommand('italic', false);
                    markUnsaved();
                    updateEmptyState();
                }
            }
        });

        // ПКМ у полі редактора
        contentEl.addEventListener('contextmenu', (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const target = e.target as HTMLElement;
            clickedImageEl = target.closest('img') as HTMLImageElement | null;
            clickedLinkEl = target.closest('a.note-link') as HTMLAnchorElement | null;
            contextTargetNoteId = null;

            saveCurrentSelection();

            if (clickedImageEl) {
                showContextMenu(e.clientX, e.clientY, false, false, true);
                return;
            }

            if (clickedLinkEl && (!savedRange || savedRange.collapsed || !clickedLinkEl.contains(savedRange.commonAncestorContainer))) {
                const r = document.createRange();
                r.selectNodeContents(clickedLinkEl);
                const sel = window.getSelection();
                sel?.removeAllRanges();
                sel?.addRange(r);
                savedRange = r.cloneRange();
            }

            showContextMenu(e.clientX, e.clientY, false, false, false);
        });
    }

    // Захист цілісності структури документа (заголовок + контент) у notes-document
    function ensureEditorStructure() {
        if (!notesDocEl) return;
        let t = document.getElementById('note-title');
        let c = document.getElementById('note-content');
        if (!t) {
            t = document.createElement('h1');
            t.id = 'note-title';
            t.className = 'note-title-input';
            t.setAttribute('data-placeholder', 'Заголовок нотатки...');
            notesDocEl.insertBefore(t, notesDocEl.firstChild);
        }
        if (!c) {
            c = document.createElement('div');
            c.id = 'note-content';
            c.className = 'note-content-editor';
            c.setAttribute('data-placeholder', 'Почніть вводити текст нотатки...');
            notesDocEl.appendChild(c);
        }
        titleEl = t;
        contentEl = c;
        // Enter can split the content block and clone its id/class. Keep all
        // paragraphs inside the saved content instead of as flex siblings.
        for (const node of Array.from(notesDocEl.childNodes)) {
            if (node === t || node === c) continue;
            if (node.nodeType === Node.TEXT_NODE && !node.textContent?.trim()) continue;
            if (node instanceof HTMLElement) {
                node.removeAttribute('id');
                node.classList.remove('note-content-editor', 'note-title-input');
                node.removeAttribute('data-empty');
                node.removeAttribute('data-placeholder');
            }
            c.appendChild(node);
        }
    }

    if (notesDocEl) {
        // Native input events target the shared contenteditable host.
        notesDocEl.addEventListener('input', () => {
            ensureEditorStructure();
            updateTitleEmptyState();
            updateEmptyState();
            markUnsaved();
        });
        notesDocEl.addEventListener('focusout', () => {
            if (isDirty && activeNoteId && !isSaving) saveCurrentNote();
        });
        if (window.MutationObserver) {
            const observer = new MutationObserver(() => {
                ensureEditorStructure();
            });
            observer.observe(notesDocEl, { childList: true });
        }

        notesDocEl.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' && !e.isComposing) {
                const selection = window.getSelection();
                const anchor = selection?.anchorNode;
                if (anchor && contentEl?.contains(anchor)) {
                    e.preventDefault();
                    document.execCommand('insertLineBreak');
                    updateEmptyState();
                    markUnsaved();
                    return;
                }
            }
            if (e.key === 'Backspace' || e.key === 'Delete') {
                const sel = window.getSelection();
                if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
                const range = sel.getRangeAt(0);

                const currentTitle = document.getElementById('note-title');
                const currentContent = document.getElementById('note-content');
                if (!currentTitle || !currentContent) return;

                const spansTitle = range.intersectsNode(currentTitle) || currentTitle.contains(range.startContainer);
                const spansContent = range.intersectsNode(currentContent) || currentContent.contains(range.endContainer);

                if (spansTitle && spansContent) {
                    e.preventDefault();
                    const totalLength = (currentTitle.textContent || '').length + (currentContent.textContent || '').length;
                    if (range.toString().length >= Math.max(1, totalLength * 0.85)) {
                        setNoteTitle('');
                        currentContent.innerHTML = '';
                        currentTitle.focus();
                    } else {
                        range.deleteContents();
                        ensureEditorStructure();
                    }
                    markUnsaved();
                    updateEmptyState();
                    updateTitleEmptyState();
                }
            }
        });
    }

    const editorCanvas = document.querySelector('.notes-editor-canvas') as HTMLElement | null;
    if (editorCanvas) {
        // Drag & Drop файлів зображень у редактор
        editorCanvas.addEventListener('dragover', (e: DragEvent) => {
            if (e.dataTransfer && Array.from(e.dataTransfer.types).includes('Files')) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
                editorCanvas.classList.add('drag-over-editor');
            }
        });

        editorCanvas.addEventListener('dragleave', (e: DragEvent) => {
            if (!editorCanvas.contains(e.relatedTarget as Node)) {
                editorCanvas.classList.remove('drag-over-editor');
            }
        });

        editorCanvas.addEventListener('drop', async (e: DragEvent) => {
            if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'));
                if (files.length > 0) {
                    e.preventDefault();
                    editorCanvas.classList.remove('drag-over-editor');
                    saveCurrentSelection();

                    for (const file of files) {
                        const url = await uploadNoteImageFile(file);
                        if (url) {
                            insertImageElement(url, file.name || 'Завантажене фото');
                        }
                    }
                }
            }
        });
    }

    function saveCurrentSelection() {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            savedRange = sel.getRangeAt(0).cloneRange();
        } else {
            savedRange = null;
        }
    }

    function restoreSelection() {
        if (savedRange) {
            const sel = window.getSelection();
            if (sel) {
                sel.removeAllRanges();
                sel.addRange(savedRange);
            }
        }
    }

    function toggleHighlight() {
        let range: Range | null = null;
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0 && !sel.isCollapsed) {
            range = sel.getRangeAt(0);
        } else if (savedRange && !savedRange.collapsed) {
            range = savedRange;
            if (sel) {
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }

        if (!range || !contentEl || !contentEl.contains(range.commonAncestorContainer)) {
            return;
        }

        let container: Node | null = range.commonAncestorContainer;
        if (container.nodeType === Node.TEXT_NODE) {
            container = container.parentElement;
        }
        const existingMark = (container as HTMLElement)?.closest('mark, span.note-highlight-gray, span[style*="background-color"]');

        if (existingMark && contentEl.contains(existingMark)) {
            const parent = existingMark.parentNode;
            while (existingMark.firstChild) {
                parent?.insertBefore(existingMark.firstChild, existingMark);
            }
            existingMark.remove();
            markUnsaved();
            updateEmptyState();
            return;
        }

        const mark = document.createElement('mark');
        mark.className = 'note-highlight-gray';

        try {
            const fragment = range.extractContents();
            mark.appendChild(fragment);
            range.insertNode(mark);

            if (sel) {
                sel.removeAllRanges();
                const newRange = document.createRange();
                newRange.selectNodeContents(mark);
                sel.addRange(newRange);
                saveCurrentSelection();
            }
        } catch (e) {
            document.execCommand('hiliteColor', false, 'rgba(255, 255, 255, 0.16)');
        }

        markUnsaved();
        updateEmptyState();
    }

    function showContextMenu(x: number, y: number, isListItem: boolean = false, isNotePinned: boolean = false, isImageTarget: boolean = false) {
        if (!contextMenu) return;

        if (isListItem) {
            if (menuPinBtn) menuPinBtn.style.display = 'flex';
            if (menuPinLabel) menuPinLabel.textContent = isNotePinned ? 'Відкріпити нотатку' : 'Закріпити зверху';
            if (menuDuplicateBtn) menuDuplicateBtn.style.display = 'flex';
            if (menuCopyContentBtn) menuCopyContentBtn.style.display = 'flex';
            if (menuMoveUpBtn) menuMoveUpBtn.style.display = 'flex';
            if (menuMoveDownBtn) menuMoveDownBtn.style.display = 'flex';
            if (menuEditorDivider) menuEditorDivider.style.display = 'none';

            if (menuInsertPhotoBtn) menuInsertPhotoBtn.style.display = 'none';
            if (menuCopyImageBtn) menuCopyImageBtn.style.display = 'none';
            if (menuCopyImageUrlBtn) menuCopyImageUrlBtn.style.display = 'none';
            if (menuViewImageBtn) menuViewImageBtn.style.display = 'none';
            if (menuDeleteImageBtn) menuDeleteImageBtn.style.display = 'none';
            if (menuFormatDivider) menuFormatDivider.style.display = 'none';

            contextMenu.querySelectorAll('[data-action="highlight"], [data-action="italic"], [data-action="bold"], [data-action="link"], [data-action="open-link"], [data-action="unlink"], [data-action="clear"]')
                .forEach(el => (el as HTMLElement).style.display = 'none');
        } else {
            if (menuPinBtn) menuPinBtn.style.display = 'none';
            if (menuDuplicateBtn) menuDuplicateBtn.style.display = 'none';
            if (menuCopyContentBtn) menuCopyContentBtn.style.display = 'none';
            if (menuMoveUpBtn) menuMoveUpBtn.style.display = activeNoteId ? 'flex' : 'none';
            if (menuMoveDownBtn) menuMoveDownBtn.style.display = activeNoteId ? 'flex' : 'none';
            if (menuEditorDivider) menuEditorDivider.style.display = activeNoteId ? 'block' : 'none';

            if (isImageTarget && clickedImageEl) {
                if (menuMoveUpBtn) menuMoveUpBtn.style.display = 'none';
                if (menuMoveDownBtn) menuMoveDownBtn.style.display = 'none';
                if (menuEditorDivider) menuEditorDivider.style.display = 'none';
                if (menuInsertPhotoBtn) menuInsertPhotoBtn.style.display = 'none';
                if (menuCopyImageBtn) menuCopyImageBtn.style.display = 'flex';
                if (menuCopyImageUrlBtn) menuCopyImageUrlBtn.style.display = 'flex';
                if (menuViewImageBtn) menuViewImageBtn.style.display = 'flex';
                if (menuDeleteImageBtn) menuDeleteImageBtn.style.display = 'flex';
                if (menuFormatDivider) menuFormatDivider.style.display = 'none';

                contextMenu.querySelectorAll('[data-action="highlight"], [data-action="italic"], [data-action="bold"], [data-action="link"], [data-action="open-link"], [data-action="unlink"], [data-action="clear"]')
                    .forEach(el => (el as HTMLElement).style.display = 'none');
            } else {
                if (menuInsertPhotoBtn) menuInsertPhotoBtn.style.display = 'flex';
                if (menuCopyImageBtn) menuCopyImageBtn.style.display = 'none';
                if (menuCopyImageUrlBtn) menuCopyImageUrlBtn.style.display = 'none';
                if (menuViewImageBtn) menuViewImageBtn.style.display = 'none';
                if (menuDeleteImageBtn) menuDeleteImageBtn.style.display = 'none';
                if (menuFormatDivider) menuFormatDivider.style.display = 'block';

                contextMenu.querySelectorAll('[data-action="highlight"], [data-action="italic"], [data-action="bold"], [data-action="link"], [data-action="clear"]')
                    .forEach(el => (el as HTMLElement).style.display = 'flex');

                if (clickedLinkEl) {
                    if (menuOpenLinkBtn) menuOpenLinkBtn.style.display = 'flex';
                    if (menuUnlinkBtn) menuUnlinkBtn.style.display = 'flex';
                    if (menuLinkLabel) menuLinkLabel.textContent = 'Змінити посилання';
                } else {
                    if (menuOpenLinkBtn) menuOpenLinkBtn.style.display = 'none';
                    if (menuUnlinkBtn) menuUnlinkBtn.style.display = 'none';
                    if (menuLinkLabel) menuLinkLabel.textContent = 'Вставити посилання';
                }
            }
        }

        contextMenu.style.display = 'flex';
        contextMenu.style.visibility = 'hidden';

        const menuWidth = contextMenu.offsetWidth || 220;
        const menuHeight = contextMenu.offsetHeight || 190;
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;

        let posX = x;
        let posY = y;

        if (posX + menuWidth > winWidth - 10) {
            posX = winWidth - menuWidth - 10;
        }
        if (posY + menuHeight > winHeight - 10) {
            posY = winHeight - menuHeight - 10;
        }

        contextMenu.style.left = `${Math.max(10, posX)}px`;
        contextMenu.style.top = `${Math.max(10, posY)}px`;
        contextMenu.style.visibility = 'visible';
    }

    function hideContextMenu() {
        if (contextMenu) {
            contextMenu.style.display = 'none';
        }
    }

    document.addEventListener('click', (e) => {
        if (contextMenu && !contextMenu.contains(e.target as Node)) {
            hideContextMenu();
        }
    });

    if (contextMenu) {
        contextMenu.querySelectorAll('.notes-menu-item').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const action = (btn as HTMLElement).getAttribute('data-action');
                handleMenuAction(action);
            });
        });
    }

    function handleMenuAction(action: string | null) {
        if (!action) return;

        if (action === 'pin') {
            const idToPin = contextTargetNoteId || activeNoteId;
            if (idToPin) {
                togglePinNote(idToPin);
            }
            hideContextMenu();
        } else if (action === 'duplicate') {
            duplicateNote(contextTargetNoteId || activeNoteId);
            hideContextMenu();
        } else if (action === 'copy-content') {
            copyFullNoteContent(contextTargetNoteId || activeNoteId);
            hideContextMenu();
        } else if (action === 'move-up') {
            const idToMove = contextTargetNoteId || activeNoteId;
            if (idToMove) {
                moveNote(idToMove, 'up');
            }
            hideContextMenu();
        } else if (action === 'move-down') {
            const idToMove = contextTargetNoteId || activeNoteId;
            if (idToMove) {
                moveNote(idToMove, 'down');
            }
            hideContextMenu();
        } else if (action === 'insert-photo') {
            hideContextMenu();
            imageFileInput?.click();
        } else if (action === 'copy-image') {
            if (clickedImageEl && clickedImageEl.src) {
                copyImageToClipboard(clickedImageEl.src);
            }
            hideContextMenu();
        } else if (action === 'copy-image-url') {
            if (clickedImageEl && clickedImageEl.src) {
                const fullUrl = new URL(clickedImageEl.src, window.location.href).href;
                navigator.clipboard.writeText(fullUrl);
                if ((window as any).showMessage) {
                    (window as any).showMessage('Посилання на фото скопійовано', 'info');
                }
            }
            hideContextMenu();
        } else if (action === 'view-image') {
            if (clickedImageEl && clickedImageEl.src) {
                openImageModal(clickedImageEl.src);
            }
            hideContextMenu();
        } else if (action === 'delete-image') {
            if (clickedImageEl) {
                clickedImageEl.remove();
                clickedImageEl = null;
                markUnsaved();
                updateEmptyState();
                saveCurrentNote();
            }
            hideContextMenu();
        } else if (action === 'highlight') {
            restoreSelection();
            toggleHighlight();
            hideContextMenu();
        } else if (action === 'italic') {
            restoreSelection();
            document.execCommand('italic', false);
            hideContextMenu();
            markUnsaved();
            updateEmptyState();
        } else if (action === 'bold') {
            restoreSelection();
            document.execCommand('bold', false);
            hideContextMenu();
            markUnsaved();
            updateEmptyState();
        } else if (action === 'clear') {
            restoreSelection();
            document.execCommand('removeFormat', false);
            const sel = window.getSelection();
            if (sel && sel.rangeCount > 0 && contentEl) {
                const r = sel.getRangeAt(0);
                const marks = contentEl.querySelectorAll('mark, span.note-highlight-gray, span[style*="background-color"]');
                marks.forEach(m => {
                    if (r.intersectsNode(m)) {
                        const parent = m.parentNode;
                        while (m.firstChild) {
                            parent?.insertBefore(m.firstChild, m);
                        }
                        m.remove();
                    }
                });
            }
            hideContextMenu();
            markUnsaved();
            updateEmptyState();
        } else if (action === 'open-link') {
            if (clickedLinkEl && clickedLinkEl.href) {
                window.open(clickedLinkEl.href, '_blank', 'noopener,noreferrer');
            }
            hideContextMenu();
        } else if (action === 'unlink') {
            if (clickedLinkEl) {
                clickedLinkEl.replaceWith(...Array.from(clickedLinkEl.childNodes));
                clickedLinkEl = null;
                markUnsaved();
                updateEmptyState();
            }
            hideContextMenu();
        } else if (action === 'link') {
            hideContextMenu();
            openLinkModal();
        }
    }

    function openLinkModal() {
        if (!linkModalOverlay) return;

        let initialText = '';
        let initialUrl = '';

        if (clickedLinkEl) {
            initialText = clickedLinkEl.textContent || '';
            initialUrl = clickedLinkEl.getAttribute('href') || '';
            if (linkModalTitle) {
                linkModalTitle.innerHTML = '<i class="ri-link"></i> <span>Змінити посилання</span>';
            }
        } else {
            initialText = savedRange ? savedRange.toString() : '';
            initialUrl = '';
            if (linkModalTitle) {
                linkModalTitle.innerHTML = '<i class="ri-link"></i> <span>Вставити посилання</span>';
            }
        }

        if (linkTextInput) linkTextInput.value = initialText;
        if (linkUrlInput) linkUrlInput.value = initialUrl;

        linkModalOverlay.style.display = 'flex';
        setTimeout(() => {
            if (!initialText && linkTextInput) {
                linkTextInput.focus();
            } else if (linkUrlInput) {
                linkUrlInput.focus();
                linkUrlInput.select();
            }
        }, 50);
    }

    function closeLinkModal() {
        if (linkModalOverlay) {
            linkModalOverlay.style.display = 'none';
        }
        clickedLinkEl = null;
    }

    function applyLink() {
        let url = linkUrlInput ? linkUrlInput.value.trim() : '';
        let text = linkTextInput ? linkTextInput.value.trim() : '';

        if (!url) {
            if (linkUrlInput) {
                linkUrlInput.focus();
                linkUrlInput.style.borderColor = '#ef4444';
                setTimeout(() => {
                    if (linkUrlInput) linkUrlInput.style.borderColor = '';
                }, 1500);
            }
            return;
        }

        if (!/^([a-z]+:)?\/\//i.test(url) && !/^(mailto|tel):/i.test(url)) {
            url = 'https://' + url;
        }

        if (!text) {
            text = url;
        }

        if (clickedLinkEl) {
            clickedLinkEl.setAttribute('href', url);
            clickedLinkEl.textContent = text;
            clickedLinkEl.setAttribute('data-tooltip', url);
            clickedLinkEl.setAttribute('data-tooltip-pos', 'top');
            clickedLinkEl.setAttribute('target', '_blank');
            clickedLinkEl.setAttribute('rel', 'noopener noreferrer');
            clickedLinkEl.classList.add('note-link');
        } else {
            restoreSelection();

            const linkEl = document.createElement('a');
            linkEl.className = 'note-link';
            linkEl.href = url;
            linkEl.target = '_blank';
            linkEl.rel = 'noopener noreferrer';
            linkEl.setAttribute('data-tooltip', url);
            linkEl.setAttribute('data-tooltip-pos', 'top');
            linkEl.textContent = text;

            if (savedRange && !savedRange.collapsed) {
                savedRange.deleteContents();
                savedRange.insertNode(linkEl);
                savedRange.setStartAfter(linkEl);
                savedRange.setEndAfter(linkEl);
                const sel = window.getSelection();
                sel?.removeAllRanges();
                sel?.addRange(savedRange);
            } else if (contentEl) {
                if (savedRange) {
                    savedRange.insertNode(linkEl);
                    savedRange.setStartAfter(linkEl);
                    savedRange.setEndAfter(linkEl);
                    const sel = window.getSelection();
                    sel?.removeAllRanges();
                    sel?.addRange(savedRange);
                } else {
                    contentEl.appendChild(linkEl);
                }
            }
        }

        closeLinkModal();
        markUnsaved();
        updateEmptyState();
        if (contentEl) contentEl.focus();
    }

    if (linkSaveBtn) linkSaveBtn.onclick = applyLink;
    if (linkCancelBtn) linkCancelBtn.onclick = closeLinkModal;
    if (linkCloseBtn) linkCloseBtn.onclick = closeLinkModal;

    if (linkModalOverlay) {
        linkModalOverlay.addEventListener('click', (e) => {
            if (e.target === linkModalOverlay) {
                closeLinkModal();
            }
        });
    }

    if (linkUrlInput) {
        linkUrlInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                applyLink();
            } else if (e.key === 'Escape') {
                closeLinkModal();
            }
        });
    }

    if (linkTextInput) {
        linkTextInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                applyLink();
            } else if (e.key === 'Escape') {
                closeLinkModal();
            }
        });
    }

    async function createNewNote() {
        if (isDirty && activeNoteId && !isSaving) {
            await saveCurrentNote();
        }

        try {
            const res = await fetch('api/notes.php?action=create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: 'Нова нотатка', content: '' })
            });
            const data = await res.json();
            if (data.success) {
                await loadNotes();
                const newNote = currentNotes.find(n => Number(n.id) === Number(data.id));
                if (newNote) {
                    openNote(newNote, true);
                    if (titleEl) {
                        titleEl.focus();
                        selectAllTitle();
                    }
                }
            }
        } catch (e) {
            console.error('Create note failed', e);
        }
    }

    async function saveCurrentNote() {
        if (!activeNoteId || isSaving) return;
        if (autoSaveTimer) {
            clearTimeout(autoSaveTimer);
            autoSaveTimer = null;
        }

        isSaving = true;
        const savingId = activeNoteId;
        const savingRevision = editRevision;
        let saveSucceeded = false;

        try {
            if (saveStatusEl) {
                saveStatusEl.innerHTML = '<i class="ri-loader-4-line ri-spin"></i> Збереження...';
                saveStatusEl.style.color = 'var(--text-dim)';
            }

            let contentToSave = '';
            if (contentEl) {
                const text = contentEl.textContent || '';
                if (!text.trim() && !contentEl.querySelector('img, a, hr')) {
                    contentToSave = '';
                } else {
                    contentToSave = contentEl.innerHTML;
                }
            }

            const titleToSave = getNoteTitle();

            const res = await fetch('api/notes.php?action=update', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: savingId,
                    title: titleToSave,
                    content: contentToSave
                })
            });
            const data = await res.json();
            if (!res.ok || !data.success) {
                throw new Error(data.error || 'Save note failed');
            }
            if (data.success) {
                saveSucceeded = true;
                if (activeNoteId === savingId && editRevision === savingRevision) {
                    setSavedState();
                }
                const activeNote = currentNotes.find(n => Number(n.id) === Number(savingId));
                if (activeNote) {
                    activeNote.title = titleToSave;
                    activeNote.content = contentToSave;
                    updateNoteListItemPreview(savingId, titleToSave, contentToSave);
                }
            }
        } catch (e) {
            console.error('Save note failed', e);
            if (saveStatusEl && activeNoteId === savingId) {
                saveStatusEl.innerHTML = '<i class="ri-error-warning-line"></i> Помилка';
                saveStatusEl.style.color = '#ef4444';
            }
        } finally {
            isSaving = false;
            if (saveSucceeded && isDirty && activeNoteId) triggerAutoSave();
        }
    }

    function updateNoteListItemPreview(noteId: any, newTitle: string, newContent: string) {
        if (!listEl) return;
        const li = listEl.querySelector(`.note-list-item[data-id="${noteId}"]`) as HTMLElement | null;
        if (!li) return;
        const titleTextEl = li.querySelector('.note-title-text');
        if (titleTextEl) {
            titleTextEl.textContent = newTitle || 'Без назви';
        }
        let snippetEl = li.querySelector('.note-item-snippet') as HTMLElement | null;
        const snippetText = formatNoteSnippet(newContent);
        if (snippetText) {
            if (!snippetEl) {
                snippetEl = document.createElement('div');
                snippetEl.className = 'note-item-snippet';
                li.appendChild(snippetEl);
            }
            snippetEl.textContent = snippetText;
        } else if (snippetEl) {
            snippetEl.remove();
        }
    }

    // Автозбереження перед закриттям або оновленням вкладки
    window.addEventListener('beforeunload', () => {
        if (isDirty && activeNoteId && contentEl) {
            const payload = JSON.stringify({
                id: activeNoteId,
                title: getNoteTitle(),
                content: contentEl.innerHTML
            });
            navigator.sendBeacon?.('api/notes.php?action=update', payload);
        }
    });

    // Автозбереження при переході на інший розділ сайту
    document.querySelectorAll('.sidebar-item').forEach(item => {
        item.addEventListener('click', () => {
            if (isDirty && activeNoteId && !isSaving) {
                saveCurrentNote();
            }
        });
    });

    async function uploadNoteImageFile(file: File): Promise<string | null> {
        const formData = new FormData();
        formData.append('image', file);

        if (saveStatusEl) {
            saveStatusEl.innerHTML = '<i class="ri-loader-4-line ri-spin"></i> Завантаження фото...';
            saveStatusEl.style.color = '#3b82f6';
        }

        try {
            const res = await fetch('api/notes.php?action=upload_image', {
                method: 'POST',
                body: formData
            });
            const data = await res.json();
            if (data.success && data.url) {
                return data.url;
            } else {
                const errMsg = data.error || 'Помилка завантаження зображення';
                if ((window as any).showMessage) (window as any).showMessage(errMsg, 'error');
                return null;
            }
        } catch (e) {
            console.error('Failed to upload image', e);
            if ((window as any).showMessage) (window as any).showMessage('Помилка передачі файлу', 'error');
            return null;
        } finally {
            setUnsavedState();
        }
    }

    function insertImageElement(src: string, altText: string = 'Фото нотатки') {
        if (!contentEl) return;
        const img = document.createElement('img');
        img.src = src;
        img.alt = altText;
        img.className = 'note-image';
        img.loading = 'lazy';

        restoreSelection();

        if (savedRange && !savedRange.collapsed) {
            savedRange.deleteContents();
            savedRange.insertNode(img);
            savedRange.setStartAfter(img);
            savedRange.setEndAfter(img);
        } else if (savedRange) {
            savedRange.insertNode(img);
            savedRange.setStartAfter(img);
            savedRange.setEndAfter(img);
        } else {
            contentEl.appendChild(img);
        }

        const p = document.createElement('div');
        p.innerHTML = '<br>';
        img.after(p);

        markUnsaved();
        updateEmptyState();
        saveCurrentNote();
    }

    function convertBlobToPng(blob: Blob): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(blob);
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth || img.width;
                canvas.height = img.naturalHeight || img.height;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    URL.revokeObjectURL(url);
                    resolve(blob);
                    return;
                }
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(pngBlob => {
                    URL.revokeObjectURL(url);
                    if (pngBlob) resolve(pngBlob);
                    else resolve(blob);
                }, 'image/png');
            };
            img.onerror = () => {
                URL.revokeObjectURL(url);
                reject(new Error('Failed to load image'));
            };
            img.src = url;
        });
    }

    async function copyImageToClipboard(imgSrc: string) {
        try {
            const response = await fetch(imgSrc);
            const blob = await response.blob();

            let pngBlob = blob;
            if (blob.type !== 'image/png') {
                pngBlob = await convertBlobToPng(blob);
            }

            if (navigator.clipboard && (window as any).ClipboardItem) {
                await navigator.clipboard.write([
                    new ClipboardItem({ 'image/png': pngBlob })
                ]);
                if ((window as any).showMessage) {
                    (window as any).showMessage('Фото скопійовано в буфер обміну', 'success');
                }
            } else {
                const fullUrl = new URL(imgSrc, window.location.href).href;
                await navigator.clipboard.writeText(fullUrl);
                if ((window as any).showMessage) {
                    (window as any).showMessage('Посилання на фото скопійовано', 'info');
                }
            }
        } catch (err) {
            console.error('Failed to copy image to clipboard', err);
            try {
                const fullUrl = new URL(imgSrc, window.location.href).href;
                await navigator.clipboard.writeText(fullUrl);
                if ((window as any).showMessage) {
                    (window as any).showMessage('Посилання на фото скопійовано', 'info');
                }
            } catch (e2) {
                if ((window as any).showMessage) (window as any).showMessage('Не вдалося скопіювати фото', 'error');
            }
        }
    }

    async function duplicateNote(idToDuplicate: any, e?: Event) {
        if (e) e.stopPropagation();
        const noteId = idToDuplicate || activeNoteId;
        if (!noteId) return;

        if (isDirty && activeNoteId && !isSaving) {
            await saveCurrentNote();
        }

        try {
            const res = await fetch('api/notes.php?action=duplicate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: noteId })
            });
            const data = await res.json();
            if (data.success && data.id) {
                if ((window as any).showMessage) {
                    (window as any).showMessage('Нотатку успішно дубльовано', 'success');
                }
                await loadNotes();
                const duplicated = currentNotes.find(n => Number(n.id) === Number(data.id));
                if (duplicated) {
                    openNote(duplicated, true);
                }
            } else {
                if ((window as any).showMessage) {
                    (window as any).showMessage(data.error || 'Помилка дублювання нотатки', 'error');
                }
            }
        } catch (err) {
            console.error('Failed to duplicate note', err);
        }
    }

    async function copyFullNoteContent(idToCopy?: any) {
        const noteId = idToCopy || activeNoteId;
        let note = currentNotes.find(n => Number(n.id) === Number(noteId));
        let title = '';
        let html = '';
        let plain = '';

        if (Number(activeNoteId) === Number(noteId) || !idToCopy) {
            title = getNoteTitle();
            html = contentEl ? contentEl.innerHTML : '';
            plain = contentEl ? (contentEl.innerText || contentEl.textContent || '') : '';
        } else if (note) {
            title = note.title || '';
            html = note.content || '';
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            plain = tmp.innerText || tmp.textContent || '';
        }

        if (!title && !plain) {
            if ((window as any).showMessage) (window as any).showMessage('Нотатка порожня', 'info');
            return;
        }

        const fullPlain = (title ? '# ' + title + '\n\n' : '') + plain;
        const fullHtml = (title ? '<h1>' + escapeHtml(title) + '</h1>' : '') + html;

        try {
            if (navigator.clipboard && (window as any).ClipboardItem) {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        'text/plain': new Blob([fullPlain], { type: 'text/plain' }),
                        'text/html': new Blob([fullHtml], { type: 'text/html' })
                    })
                ]);
            } else {
                await navigator.clipboard.writeText(fullPlain);
            }
            if ((window as any).showMessage) {
                (window as any).showMessage('Вміст нотатки скопійовано в буфер', 'success');
            }
        } catch (err) {
            console.error('Failed to copy note', err);
            await navigator.clipboard.writeText(fullPlain);
            if ((window as any).showMessage) {
                (window as any).showMessage('Текст нотатки скопійовано', 'success');
            }
        }
    }

    function openImageModal(src: string) {
        if (!imageModalOverlay || !imageModalImg) return;
        imageModalImg.src = src;
        if (imageModalDownloadBtn) {
            imageModalDownloadBtn.href = src;
            const parts = src.split('/');
            imageModalDownloadBtn.download = parts[parts.length - 1] || 'note-photo.png';
        }
        imageModalOverlay.style.display = 'flex';
    }

    function closeImageModal() {
        if (imageModalOverlay) {
            imageModalOverlay.style.display = 'none';
        }
    }

    if (imageFileInput) {
        imageFileInput.addEventListener('change', async () => {
            if (imageFileInput.files && imageFileInput.files.length > 0) {
                const file = imageFileInput.files[0];
                const url = await uploadNoteImageFile(file);
                if (url) {
                    insertImageElement(url, file.name || 'Фото нотатки');
                }
                imageFileInput.value = '';
            }
        });
    }

    if (imageModalCloseBtn) imageModalCloseBtn.onclick = closeImageModal;
    if (imageModalOverlay) {
        imageModalOverlay.addEventListener('click', (e) => {
            if (e.target === imageModalOverlay) {
                closeImageModal();
            }
        });
    }
    if (imageModalCopyBtn) {
        imageModalCopyBtn.onclick = () => {
            if (imageModalImg && imageModalImg.src) {
                copyImageToClipboard(imageModalImg.src);
            }
        };
    }

    if (newBtn) newBtn.onclick = createNewNote;
    if (emptyNewBtn) emptyNewBtn.onclick = createNewNote;
    if (headerAddBtn) headerAddBtn.onclick = createNewNote;

    if (saveBtn) saveBtn.onclick = saveCurrentNote;

    if (pinBtn) {
        pinBtn.onclick = () => {
            if (activeNoteId) {
                togglePinNote(activeNoteId);
            }
        };
    }

    if (backBtn) {
        backBtn.onclick = async () => {
            if (isDirty && activeNoteId && !isSaving) {
                await saveCurrentNote();
            }
            hideMobileEditor();
        };
    }

    if (deleteBtn) {
        deleteBtn.onclick = () => {
            if (!activeNoteId) return;
            const doDelete = async () => {
                try {
                    const res = await fetch('api/notes.php?action=delete&id=' + activeNoteId);
                    const data = await res.json();
                    if (data.success) {
                        if ((window as any).showMessage) (window as any).showMessage('Нотатку видалено', 'success');
                        activeNoteId = null;
                        hideMobileEditor();
                        await loadNotes();
                    }
                } catch (e) {
                    console.error('Delete note failed', e);
                }
            };

            if (typeof (window as any).showConfirm === 'function') {
                (window as any).showConfirm('Видалити цю нотатку?', doDelete, {
                    title: 'Видалення нотатки',
                    confirmText: 'Видалити',
                    cancelText: 'Скасувати'
                });
            } else {
                doDelete();
            }
        };
    }

    if (searchInput) {
        searchInput.addEventListener('input', (e: any) => {
            searchQuery = e.target.value || '';
            renderNotesList();
        });
    }

    // Density toggle (звичайний вигляд з прев'ю / ультракомпактний без сніпетів)
    const densityBtn = document.getElementById('notes-density-btn');
    const sidebarEl = document.getElementById('notes-sidebar');
    let isCompactDensity = localStorage.getItem('syncflow_notes_compact') === 'true';

    function updateDensityUI() {
        if (!sidebarEl) return;
        if (isCompactDensity) {
            sidebarEl.classList.add('compact-density');
            if (densityBtn) {
                densityBtn.classList.add('active');
                densityBtn.title = 'Звичайний вигляд (показати прев\'ю)';
                densityBtn.innerHTML = '<i class="ri-list-check"></i>';
            }
        } else {
            sidebarEl.classList.remove('compact-density');
            if (densityBtn) {
                densityBtn.classList.remove('active');
                densityBtn.title = 'Компактний вигляд (приховати прев\'ю)';
                densityBtn.innerHTML = '<i class="ri-menu-unfold-line"></i>';
            }
        }
    }

    if (densityBtn) {
        densityBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            isCompactDensity = !isCompactDensity;
            localStorage.setItem('syncflow_notes_compact', isCompactDensity ? 'true' : 'false');
            updateDensityUI();
        });
    }
    updateDensityUI();

    // Keyboard shortcut Ctrl+S / Cmd+S, Alt+Up / Alt+Down and Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && imageModalOverlay && imageModalOverlay.style.display === 'flex') {
            closeImageModal();
            return;
        }

        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
            const notesPanel = document.getElementById('notes');
            if (notesPanel && notesPanel.classList.contains('active')) {
                e.preventDefault();
                saveCurrentNote();
            }
        }

        if (e.altKey && (e.key === 'ArrowUp' || e.key === 'Up')) {
            const notesPanel = document.getElementById('notes');
            if (notesPanel && notesPanel.classList.contains('active') && activeNoteId) {
                e.preventDefault();
                moveNote(activeNoteId, 'up');
            }
        } else if (e.altKey && (e.key === 'ArrowDown' || e.key === 'Down')) {
            const notesPanel = document.getElementById('notes');
            if (notesPanel && notesPanel.classList.contains('active') && activeNoteId) {
                e.preventDefault();
                moveNote(activeNoteId, 'down');
            }
        }
    });

    // Реакція на зміну орієнтації або ресайз екрана
    window.addEventListener('resize', () => {
        if (!isMobileView() && containerEl) {
            containerEl.classList.remove('mobile-view-editor');
        }
    });

    function escapeHtml(str: string) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    const notesTabBtn = document.querySelector('button[data-tab="notes"]');
    if (notesTabBtn) {
        notesTabBtn.addEventListener('click', () => {
            loadNotes();
        });
    }

    loadNotes();
});
